var _path, _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardChart2 = function SvgCardChart2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 91,
    viewBox: "0 0 95 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1514 3.5C66.6379 3.5 84.8026 21.5251 84.8027 43.6816C84.8027 65.8383 66.638 83.8633 44.1514 83.8633C21.6648 83.8632 3.5 65.8382 3.5 43.6816C3.5001 21.5252 21.6649 3.50008 44.1514 3.5Z",
    fill: "black",
    stroke: "#E7F58D",
    strokeWidth: 7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.7883,
    cy: 46.0305,
    r: 43.2121,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeDasharray: "5 5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.2734,
    y: 26.3027,
    width: 4.69697,
    height: 28.1818,
    fill: "#65C9DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.1797,
    y: 28.6562,
    width: 5.52312,
    height: 39.3705,
    transform: "rotate(60 71.1797 28.6562)",
    fill: "#65C9DB"
  })));
};
export default SvgCardChart2;